import React from 'react'
import { Popup } from 'semantic-ui-react'

interface Consumer {
  name: string
  type: string
  last_accessed: string
  access_count: number
}

interface UsedBySectionProps {
  consumers: Consumer[]
}

const UsedBySection: React.FC<UsedBySectionProps> = ({ consumers }) => {
  // Agent descriptions mapping
  const agentDescriptions: { [key: string]: string } = {
    'Schema Mapping Agent': 'Analyzes CSV file structure and suggests canonical field mappings',
    'Client Table Mapping Agent': 'Maps canonical field names to PostgreSQL database schema',
    'Validation & Transformation Agent': 'Validates and transforms data based on plain-language rules',
    'Identity Resolution Agent': 'Performs identity matching and deduplication with hierarchical matching',
    'Conflict Resolution Agent': 'Resolves field-level conflicts when merging records from different sources',
    'Validation Agent': 'Validates and transforms data based on plain-language rules'
  }

  return (
    <div className="file-models-section">
      <h3 className="section-title">Used By Models & Systems</h3>
      <div className="models-tags">
        {consumers.length > 0 ? (
          consumers.map((consumer, index) => (
            <Popup
              key={index}
              trigger={<span className="model-tag clickable">{consumer.name}</span>}
              position="top center"
              on="click"
              className="model-popup"
            >
              <div className="model-popup-content">
                
                {agentDescriptions[consumer.name] && (
                  <div className="model-popup-section">
                    <div className="model-popup-label">Description</div>
                    <div className="model-popup-description">{agentDescriptions[consumer.name]}</div>
                  </div>
                )}
                </div>
            </Popup>
          ))
        ) : (
          <span className="model-tag">No consumers</span>
        )}
      </div>
    </div>
  )
}

export default UsedBySection
